import {
  CreateCustomMapRequest,
  CustomMap,
  ShareCustomMapRequest,
  UpdateCustomMapRequest,
} from 'src/types/insight-builder'
import { BaseClient } from 'src/common-services/clients/base-client'

export class CustomMapClient extends BaseClient {
  getCustomMaps(): Promise<CustomMap[]> {
    return this.call<CustomMap[]>(`/custom-maps`, 'GET')
  }
  getCustomMapsByUserId(userId: string): Promise<CustomMap[]> {
    return this.call<CustomMap[]>(`/custom-maps/user/${userId}`, 'GET')
  }
  createCustomMap(request: CreateCustomMapRequest): Promise<CustomMap> {
    return this.call<CustomMap>(`/custom-maps`, 'POST', { data: request })
  }
  updateCustomMap(request: UpdateCustomMapRequest): Promise<CustomMap> {
    return this.call<CustomMap>(`/custom-maps/${request.id}`, 'PUT', {
      data: {
        data: request.data,
        title: request.title,
      },
    })
  }
  deleteCustomMap(id: string): Promise<void> {
    return this.call<void>(`/custom-maps/${id}`, 'DELETE')
  }
  shareCustomMap(request: ShareCustomMapRequest): Promise<CustomMap> {
    return this.call<CustomMap>(`/custom-maps/share`, 'POST', { data: request })
  }
}
